import { render, staticRenderFns } from "./HowToHeader.vue?vue&type=template&id=506ae9d4&scoped=true&"
import script from "./HowToHeader.vue?vue&type=script&lang=ts&"
export * from "./HowToHeader.vue?vue&type=script&lang=ts&"
import style0 from "./HowToHeader.vue?vue&type=style&index=0&id=506ae9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ae9d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
